module.exports = __webpack_public_path__ + "static/img/Marion.00b76e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Marion.jpg
// module id = 6Sac
// module chunks = 1